import React from 'react'
import { Block } from '@comp/crRender'
import SectionCard from '../../shared/SectionCard'
import './style.css'

const APLINK = import.meta.env.VITE_API_URL

const Certifications = ({ certifications }) => {
    return (
        <Block isRender={certifications?.length > 0}>
            <SectionCard icon="mdi:certificate" titleKey="certifications">
                <div className="certifications-grid">
                    {certifications?.map((cert, index) => (
                        <div key={index} className="certification-item">
                            <img 
                                src={`${APLINK}/${cert}`}
                                alt="Certification" 
                                className="certification-image"
                                onError={(e) => e.target.src = './images/cert-placeholder.jpg'}
                            />
                        </div>
                    ))}
                </div>
            </SectionCard>
        </Block>
    )
}

export default Certifications

